import SelectedItem from './selectedItem';

export default function Dashboard () {
  return (
    <>
      <SelectedItem />
    </>
  )
}
